module.exports = __webpack_public_path__ + "img/writersblock.d50e07de.jpg";